function addToCart(event) {
  let button = event.target;
  let productCard = button.closest(".bundle_group-product-card");
  let productTitle = productCard.querySelector(".product-card__title").innerText;
  let variantId = productCard.querySelector(".product-card__weight").getAttribute("data-product-variant");
  let variantPrice = productCard.querySelector(".product-card__price").getAttribute("data-price");
  let input_wrapper = productCard.querySelector(".product-card__quantitiy-wrapper");
  input_wrapper.classList.add('added-to-cart');

  let quantityInput = productCard.querySelector(".product-card__quantitiy-wrapper .quantity_input");
  let currentValue = parseInt(quantityInput.value);
  let newValue = currentValue + 1;
  quantityInput.value = newValue;

  let myData = [{ 'id': variantId, 'quantity': 1, 'properties': { "vleespakket": "gepersonaliseerd" } }];

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: myData })
  })
  .then(response => {
    if (!response.ok) {
      return response.json().then(err => { throw err; });
    }
    return response.json();
  })
  .then(() => {
    updateBundleOverview();
    updateMobileBundleOverview();
    cartCount();
    updateCartDrawerSection();
    showCartNotification(productTitle);
  })
  .catch(error => {
    alert(`!Error ${error.description || "Something went wrong"} Try Again...`);
    console.error("Cart Add Error:", error);
  });
}

function removeFromCart(event) {
  let button = event.target;
  let productCard = button.closest(".bundle_group-product-card");
  let variantId = productCard.querySelector(".product-card__weight").getAttribute("data-product-variant");
  let quantityInput = productCard.querySelector(".product-card__quantitiy-wrapper .quantity_input");
  let input_wrapper = productCard.querySelector(".product-card__quantitiy-wrapper");
  let currentValue = parseInt(quantityInput.value);
  let newValue = currentValue - 1;

  if (newValue >= 0) {
    quantityInput.value = newValue;
  fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    const itemToUpdate = cart.items.find(item => {
      return item.variant_id == variantId &&
      item.properties && item.properties["vleespakket"] === "gepersonaliseerd";
    });

    if (itemToUpdate) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemToUpdate.key, quantity: newValue })
      });
    } else {
      throw new Error("Item with specific properties not found in cart");
    }
  })
  .then(res => {
    if (!res.ok) return res.json().then(err => { throw err });
    return res.json();
  })
  .then(() => {
      updateBundleOverview();
      updateMobileBundleOverview();
      cartCount();
      updateCartDrawerSection();
      if (newValue === 0) {
        input_wrapper.classList.remove('added-to-cart');
      }
    })
    .catch(error => {
      alert(`Error: ${error.description || "Something went wrong"}. Try Again...`);
      console.error("Cart Update Error:", error);
    });
  }
}

// add-to-cart: box
function addToCartBox(event) {
  let button = event.target;
  let productCard = button.parentElement.closest(".bundle-box__items-wrapper");
  let variantId = productCard.getAttribute("data-variant-id");
  let quantityInput = productCard.querySelector(".bundle-box__item-quantity.quantity_input");
  let actualProductCard = document.querySelector(`[data-selector="${variantId}"]`);
  let currentValue = parseInt(quantityInput.value);
  let newValue = currentValue + 1;
  actualProductCard.value = newValue;
  quantityInput.value = newValue;
  let myData = [];
  myData.push({ 'id':variantId,'quantity': 1, 'properties':{"vleespakket": "gepersonaliseerd"} });

  if (myData.length > 0) {
    let data = { items: myData };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => { throw err; });
      }
      return response.json();
    })
    .then(() => {
      updateBundleOverview();
      updateMobileBundleOverview();
      cartCount();
      updateCartDrawerSection();
      let cartCountContainer = document.querySelector('.thb-item-count');
      if (cartCountContainer) {
        let cartCount = Number(cartCountContainer.textContent) || 0;
        let updatedCount = cartCount + (typeof total_Qt !== 'undefined' ? total_Qt : 0);
        cartCountContainer.textContent = updatedCount;
      }
    })
    .catch(error => {
      alert(`!Error ${error.description || "Something went wrong"} Try Again...`);
      console.error("Cart Add Error:", error);
    });
    console.log(myData);
  } else {
    alert("!Error Try Again...");
  }
};

function removeFromCarBox(event) {
  let button = event.target;
  let productCard = button.parentElement.closest(".bundle-box__items-wrapper");
  let variantId = productCard.getAttribute("data-variant-id");
  let quantityInput = productCard.querySelector(".bundle-box__item-quantity.quantity_input");
  let actualProductCard = document.querySelector(`[data-selector="${variantId}"]`);
  let input_wrapper = actualProductCard.parentElement.parentElement;
  let currentValue = parseInt(quantityInput.value);
  let newValue = currentValue - 1;

  if (newValue >= 0) {
    quantityInput.value = newValue;
    actualProductCard.value = newValue;

    fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    const itemToUpdate = cart.items.find(item => {
      return item.variant_id == variantId &&
      item.properties && item.properties["vleespakket"];
    });

    if (itemToUpdate) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemToUpdate.key, quantity: newValue })
      });
    } else {
      throw new Error("Item with specific properties not found in cart");
    }
  })
  .then(res => {
    if (!res.ok) return res.json().then(err => { throw err });
    return res.json();
  })
    .then(() => {
      updateBundleOverview();
      updateMobileBundleOverview();
      cartCount();
      updateCartDrawerSection();
      if (newValue === 0) {
        input_wrapper.classList.remove('added-to-cart');
      }
    })
    .catch(error => {
      alert(`Error: ${error.description || "Something went wrong"}. Try Again...`);
      console.error("Cart Update Error:", error);
    });
  }
};

function resetProductCardStates() {
  // Reset all product cards to initial state
  document.querySelectorAll('.bundle_group-product-card').forEach(card => {
    let input_wrapper = card.querySelector('.product-card__quantitiy-wrapper');
    let quantityInput = card.querySelector('.product-card__quantitiy-wrapper .quantity_input');

    input_wrapper.classList.remove('added-to-cart');
    quantityInput.value = '0';
  });
}

function updateBundleOverview() {
  let section = document.querySelector("[id^='bundle-box-'][data-section-id]");
  if (!section) {
    console.error("Section not found.");
    return;
  }
  const sectionId = section.getAttribute("data-section-id");
  const url = new URL(window.location);
  url.searchParams.set("section_id", sectionId);
  const urlString = url.toString();

  fetchCart(urlString, sectionId);

  async function fetchCart(urlString, sectionId) {
    try {
      let response = await fetch(urlString);
      let text = await response.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(text, 'text/html');
      const updatedContent = newDocument.querySelector(".bundle-box__overview");
      if (updatedContent) {
        document.querySelector(".bundle-box__overview").innerHTML = updatedContent.innerHTML;

        // Check if cart is empty and reset product states if needed
        const emptyCartMessage = document.querySelector('.empty-cart');
        if (emptyCartMessage && emptyCartMessage.style.display !== 'none') {
          resetProductCardStates();
        }
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  }
}

function cartCount() {
  
  fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    let cartCountMobile = document.querySelector('[data-header-cart-counts]');
    cartCountMobile.textContent = cart.item_count;
  })
  .catch(error => {
    alert(`Error: ${error.description || "Something went wrong"}. Try Again...`);
    console.error("Cart Update Error:", error);
  });
  
  let section = document.querySelector("[id^='update-'][data-section-id]");
  if (!section) {
    console.error("Section not found.");
    return;
  }

  const sectionId = section.getAttribute("data-section-id");
  const url = new URL(window.location);
  url.searchParams.set("section_id", sectionId);
  const urlString = url.toString();

  fetchCart(urlString, sectionId);

  async function fetchCart(urlString, sectionId) {
    try {
      let response = await fetch(urlString);
      let text = await response.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(text, 'text/html');
      const updatedContent = newDocument.querySelector("[data-section-id]");
      if (updatedContent) {
        document.querySelector("[data-section-id]").innerHTML = updatedContent.innerHTML;
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  }
}

function updateCartDrawerSection(cartQuantity, cartSubTotal) {
  
  setTimeout(() => {
  fetch('/cart?id=site-cart-sidebar')
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, 'text/html');
      const updatedSection = newDocument.querySelector('[data-section-drawer]');
      if (updatedSection) {
        const sidebarDrawer = document.querySelector('[data-section-drawer]');
        // Store a reference to the hide method before changing innerHTML
        const originalHideMethod = sidebarDrawer.hide;
        // Update the content
        sidebarDrawer.innerHTML = updatedSection.innerHTML;
        sidebarDrawer.classList.remove('cart-is-empty');

        // Restore the hide method if it was lost
        if (typeof sidebarDrawer.hide !== 'function') {
          sidebarDrawer.hide = originalHideMethod;
        }

        // Reattach event listener to the close button
        const closeButton = sidebarDrawer.querySelector('.sidebar__close');
        if (closeButton) {
          // Remove any existing event listeners
          const newCloseButton = closeButton.cloneNode(true);
          closeButton.parentNode.replaceChild(newCloseButton, closeButton);

          // Add new event listener that calls the hide method
          newCloseButton.addEventListener('click', function(e) {
            e.preventDefault();
            if (typeof sidebarDrawer.hide === 'function') {
              sidebarDrawer.hide();
            } else {
              // Fallback in case the hide method is not available
              document.body.classList.remove('sidebar-opened');
              document.body.classList.remove('sidebar-opened--right');
              sidebarDrawer.classList.remove('sidebar--opened');
              setTimeout(() => {
                sidebarDrawer.style.display = 'none';
              }, 501);
            }
          });
        }
      }
    })
    .catch((error) => {
      console.error('Error updating the section:', error);
    });
  }, 1000);
}


function updateMobileBundleOverview() {
  let section = document.querySelector("[id^='mobile-box-'][data-section-id]");
  if (!section) {
    console.error("Section not found.");
    return;
  }
  const sectionId = section.getAttribute("data-section-id");
  const url = new URL(window.location);
  url.searchParams.set("section_id", sectionId);
  const urlString = url.toString();
  fetchMobileBox(urlString, sectionId);

  async function fetchMobileBox(urlString, sectionId) {
    try {
      let response = await fetch(urlString);
      let text = await response.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(text, 'text/html');
      const updatedContent = newDocument.querySelector(".bundle-box__overview");
      if (updatedContent) {
        document.querySelector(".mobile-box .bundle-box__overview").innerHTML = updatedContent.innerHTML;

        // Check if cart is empty and reset product states if needed
        const emptyCartMessage = document.querySelector('.mobile-box .empty-cart');
        if (emptyCartMessage && emptyCartMessage.style.display !== 'none') {
          resetProductCardStates();
        }
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  }
}

document.querySelector(".search-icon").addEventListener("click", function () {
  let searchWrapper = document.querySelector(".search-icon_wrapper");
  searchWrapper.classList.toggle('search-active');
});

document.querySelector(".search__close").addEventListener("click", function () {
  let searchWrapper = document.querySelector(".search-icon_wrapper");
  searchWrapper.classList.remove('search-active');

  let searchText = document.querySelector(".search-input");
  searchText.value="";

  document.querySelectorAll(".bundle_group-wrapper").forEach(wrapper => {
    wrapper.querySelectorAll(".bundle_group-product-card").forEach(card => {
        card.style.display = "block";
    });
    wrapper.style.display =  "block";
  });
});

// Add click outside handler
document.addEventListener('click', function(event) {
  let searchWrapper = document.querySelector(".search-icon_wrapper");
  let searchInput = document.querySelector(".search-input");
  let searchIcon = document.querySelector(".search-icon");

  // Check if click is outside search elements
  if (!searchWrapper.contains(event.target) && !searchIcon.contains(event.target)) {
    searchWrapper.classList.remove('search-active');
    searchInput.value = "";

    document.querySelectorAll(".bundle_group-wrapper").forEach(wrapper => {
      wrapper.querySelectorAll(".bundle_group-product-card").forEach(card => {
          card.style.display = "block";
      });
      wrapper.style.display =  "block";
    });
  }
});

document.querySelector(".search-input").addEventListener("input", function () {
  let searchText = this.value.toLowerCase().trim();

  document.querySelectorAll(".bundle_group-wrapper").forEach(wrapper => {
    let hasVisibleProduct = false;

    wrapper.querySelectorAll(".bundle_group-product-card").forEach(card => {
      let productName = card.querySelector(".product-card__title .title")?.textContent.toLowerCase().trim();
      if (productName.includes(searchText)) {
        card.style.display = "block";
        hasVisibleProduct = true;
      } else {
        card.style.display = "none";
      }
    });

    wrapper.style.display = hasVisibleProduct ? "block" : "none";
  });
});


function showCartNotification(productName) {
  const notification = document.getElementById('cart-notification');
  const productNameElement = notification.querySelector('.cart-notification__product-name');

  productNameElement.textContent = productName;
  notification.style.display = 'block';

  setTimeout(() => {
    notification.style.animation = 'fade 0.3s ease-out';
    setTimeout(() => {
      notification.style.display = 'none';
      notification.style.animation = 'fade 0.3s ease-out';
    }, 300);
  }, 2000);
}

(function () {
    window.onpageshow = function(event) {
        if (event.persisted) {
            window.location.reload();
        }
    };
})();
